<template>
  <v-card flat height="100%">
    <v-expansion-panels tile accordion>
      <!-- Docu expansion panel -->
      <v-expansion-panel>
        <v-expansion-panel-header class="px-3 py-2">
          <v-row align="center">
            <v-col cols="1"><v-icon>assignment</v-icon></v-col>
            <v-col>
              <span class="red-dot"></span>
              <span class="ml-2">{{ $t('common:documentation_plural') }} ({{ docuDocumentation.length }})</span>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-list flat>
            <v-list-item-group >
              <v-list-item v-for="item in docuDocumentation" :key="item.id" @click="viewDocumentationFromSidebar(item)">                               
                <pdf
                    ref="pdf"
                    v-if="item.fileType === 'application/pdf'"
                    :src="item.src"
                    class="docu-preview-small mr-5"
                >
                </pdf>
                <img
                    v-else-if="item.fileType !== 'application/pdf'"
                    id="image"
                    :src="item.src"
                    class="docu-preview-small mr-5"
                />
                <span class="ml-2">{{ item.name }}</span>

              </v-list-item>             
            </v-list-item-group>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
      
      <!-- TODO add extra panel according to design, when it is possible to take videos -->
    </v-expansion-panels> 
  </v-card>
</template>
<script>
export default {
  name: 'ProcessDocuSidebar',
  components: {
    pdf: () => import('vue-pdf'),
  },
  data() {
    return {
      docuDocumentation: []
    }
  },
  methods: {
    viewDocumentationFromSidebar(item) {
      this.$emit('viewDocumentationFromSidebar', item)
    },

    clearDocumentatinos() {
      this.docuDocumentation = [];      
    }
  }
}
</script>
<style lang="scss">
  .docu-preview-small {
    border-radius: 50%;  /* Rounded border */
    padding: 5px; /* Some padding */
    width: 50px;
  }
</style>